import { getConfig as coreGetConfig } from '@yi/core';

import { getEnv } from './utilities';

export const getConfig = (key: Parameters<typeof coreGetConfig>[1]) => {
  const env = getEnv();
  return env && coreGetConfig(env, key);
};
